import cache from './cache';
import config from './config';

const auth = {
  /**
   * 检查用户是否已登录
   * @returns {boolean} 是否已登录
   */
  isLoggedIn() {
    return !!cache.get(config.cacheKey.userToken);
  },

  /**
   * 获取用户信息
   * @returns {Object|null} 用户信息对象，未登录或解析失败时返回null
   */
  getUserInfo() {
    if (!this.isLoggedIn()) {
      return null;
    }

    try {
      const userInfoStr = cache.get(config.cacheKey.userInfo);
      return userInfoStr ? JSON.parse(userInfoStr) : null;
    } catch (e) {
      console.error('解析用户信息失败:', e);
      return null;
    }
  },

  /**
   * 退出登录
   */
  logout() {
    cache.del(config.cacheKey.userToken);
    cache.del(config.cacheKey.userInfo);
  }
};

export default auth; 